import { createSelector } from 'reselect';
import { mapToArray } from '../mappers';

export const selectUploadStatus = (state) =>
  state.uploadDocuments?.uploadStatus;

export const selectUploadersHistory = createSelector(
  [(state) => state.uploadDocuments?.uploadersHistory],
  (values) => (values ? mapToArray(values) : [])
);

export const selectUploadHistoryStatus = (state) =>
  state.uploadDocuments?.uploadHistory?.historyStatus;

export const selectUploadHistory = createSelector(
  [(state) => state.uploadDocuments?.uploadHistory?.data],
  (values) => (values ? mapToArray(values) : [])
);

export const selectUploadHistoryIds = createSelector(
  [selectUploadHistory],
  (history) => history.map(({ id }) => id)
);

export const selectUploadedHistoryLength = createSelector(
  [selectUploadHistory],
  (history) => history.length || null
);

export const selectUploadHistoryTableData = createSelector(
  [selectUploadHistory],
  (uploadHistoryArray) =>
    uploadHistoryArray.map(
      ({
        createdAt,
        name,
        size,
        id,
        key,
        clientEmail,
        type,
        uploadError,
        mistaken,
      }) => ({
        date: createdAt,
        fileName: name,
        size,
        key: id,
        isDownloadable: !!key,
        clientEmail,
        type,
        uploadError,
        mistaken,
      })
    )
);

export const selectUploadHistoryMeta = (state) =>
  state.uploadDocuments?.uploadHistory?.meta || {};

export const selectUploadHistoryDownloadedBool = createSelector(
  [selectUploadHistoryMeta, selectUploadedHistoryLength],
  (meta, downloadedAmount) => {
    const { total, limit, page } = meta;
    return total <= downloadedAmount || total - limit * page < 0;
  }
);

export const selectDownloadingDocumentsList = (state) =>
  state.uploadDocuments?.downloadingDocumentsList;
